import { LANG_NOTE, NURSE_REVIEW_NOTE, type Lang } from '@aithora/shared';
import { sx } from '../ui/designStyles';
import { useLang } from './LangContext';

/**
 * The Language row of Settings > Channels (Console V6 design, data-screen-label "Language":
 * a LANGUAGE label, English / Español, and a note). The note says only what is true, and
 * the nurse-review note lives here and nowhere else (never on a care screen).
 */
const OPTIONS: [Lang, string][] = [
  ['en', 'English'],
  ['es', 'Español'],
];

const pill = (on: boolean) =>
  'display:inline-flex;align-items:center;height:30px;padding:0 12px;border-radius:7px;font-size:16px;font-weight:700;text-decoration:none;white-space:nowrap;cursor:pointer;font-family:inherit;' +
  (on ? 'color:#fff;background:#264C7E;border:1px solid #264C7E;' : 'color:#3C454F;background:transparent;border:1px solid rgba(34,39,46,.16);');

export function LanguageRow() {
  const { lang, setLang, saved } = useLang();
  return (
    <div
      data-screen-label="Language"
      data-testid="language-row"
      style={sx('display:flex;align-items:center;gap:8px 14px;flex-wrap:wrap;padding:10px 12px;border:1px solid rgba(34,39,46,.12);border-radius:10px;')}
    >
      <span id="language-label" style={sx('font-size:14px;letter-spacing:.11em;text-transform:uppercase;color:#54606C;font-weight:600;')}>
        Language
      </span>
      <span role="radiogroup" aria-labelledby="language-label" style={sx('display:flex;gap:4px;')}>
        {OPTIONS.map(([code, label]) => (
          <button
            key={code}
            type="button"
            role="radio"
            aria-checked={lang === code}
            lang={code}
            translate="no"
            data-testid={`lang-${code}`}
            onClick={() => setLang(code)}
            style={sx(pill(lang === code))}
          >
            {label}
          </button>
        ))}
      </span>
      <span style={sx('flex:1 1 240px;min-width:0;font-size:16px;color:#54606C;line-height:1.45;')}>
        <span>{LANG_NOTE}</span>
        {saved && (
          <span data-testid="lang-saved" style={sx('display:block;margin-top:2px;')}>
            {saved === 'account' ? 'Your language is saved to your account.' : 'Saved on this device only. It could not be saved to your account.'}
          </span>
        )}
      </span>
      <span data-testid="nurse-review-note" style={sx('flex:1 1 100%;font-size:14px;font-weight:600;color:#8A5A00;')}>
        {NURSE_REVIEW_NOTE}
      </span>
    </div>
  );
}
